import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Breadcrumb, Spin, Switch, message, Card } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import AntdProForm, { ProFormText, ProFormSelect } from '@ant-design/pro-form';
import { useQuery, useMutation } from '@apollo/client';
import {
  UPDATE_DEPARTMENT,
  GET_DEPARTMENTS,
  GET_FACULTIES,
} from 'gql/faculties';
import ProSelectFaculty from 'components/layout/ProSelectFaculty';
import ProForm from 'components/layout/ProForm';

const EditFaculty = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_DEPARTMENTS, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [form] = AntdProForm.useForm();
  const [updateDepartment, { loading: updateDepartmentLoading }] = useMutation(
    UPDATE_DEPARTMENT,
    {
      refetchQueries: [
        { query: GET_FACULTIES, variables: { state: 'ALL' } },
        { query: GET_DEPARTMENTS, variables: { state: 'ALL', ids: [id] } },
      ],
      onCompleted: ({ updateDepartment }) => {
        message.success(`${updateDepartment.abbreviation} successfully edited`);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );

  if (loading) {
    return (
      <PageContainer
        header={{
          title: 'Edit Department',
        }}
        loading
      />
    );
  }

  const department = data.departments[0];

  return (
    <PageContainer
      header={{
        title: 'Edit Department',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/faculties">Faculties</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/system-setting/faculties/${department.faculty.id}`}>
                {department.faculty.abbreviation}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{department.abbreviation}</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Spin spinning={updateDepartmentLoading} tip="Updating...">
        <Card bordered={false}>
          <ProForm
            form={form}
            backPage={`/system-setting/faculties/${department.faculty.id}`}
            onFinish={(input) => {
              updateDepartment({
                variables: {
                  updateDepartmentInput: {
                    id: id,
                    disabled: !input.active,
                    deleted: false,
                    name: input.name,
                    abbreviation: input.abbreviation,
                    faculty: input.faculty,
                    controlType: input.controlType,
                  },
                },
              });
            }}
            initialValues={{
              name: department.name,
              abbreviation: department.abbreviation,
              controlType: department.controlType,
              faculty: department.faculty.id,
              active: !department.disabled,
            }}
          >
            <ProFormText
              width="xl"
              name="name"
              label="Name"
              placeholder="name"
              rules={[
                { required: true, message: 'Please enter department name!' },
              ]}
            />
            <ProFormText
              width="xl"
              name="abbreviation"
              label="Abbreviation"
              placeholder="abbreviation"
              rules={[
                {
                  required: true,
                  message: 'Please enter department abbreviation!',
                },
              ]}
            />
            <ProSelectFaculty
              name="faculty"
              label="Faculty"
              width="xl"
              placeholder="Please select"
              rules={[
                {
                  required: true,
                  message: 'Please select faculty!',
                },
              ]}
            />
            <ProFormSelect
              width="xl"
              name="controlType"
              label="Control Type"
              rules={[
                {
                  required: true,
                  message: 'Please select control type!',
                },
              ]}
              valueEnum={{
                DEPARTMENT: 'DEPARTMENT',
                FACULTY: 'FACULTY',
                SCHOOL: 'SCHOOL',
                NAU: 'NAU',
              }}
            />
            <AntdProForm.Item
              name="active"
              label="Active"
              valuePropName="checked"
            >
              <Switch />
            </AntdProForm.Item>
          </ProForm>
        </Card>
      </Spin>
    </PageContainer>
  );
};

export default EditFaculty;
